// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2B-tP","footer":"ModalError_footer__Nx3oM"};